export const SHOW_SUCCESSFUL_MESSAGE = 'SHOW_SUCCESSFUL_MESSAGE';
export const SHOW_INFO_MESSAGE = 'SHOW_INFO_MESSAGE';
export const SHOW_WARNING_MESSAGE = 'SHOW_WARNING_MESSAGE';
export const SHOW_ERROR_MESSAGE = 'SHOW_ERROR_MESSAGE';

export const LOGGED_IN_MESSAGE = 'LOGGED_IN_MESSAGE';

export const SCROLL_DASHBOARD_TO_TOP = 'SCROLL_DASHBOARD_TO_TOP';

export const UPDATE_SHOW_LOADING = 'UPDATE_SHOW_LOADING';

export const USER_LOGOUT = 'USER_LOGOUT';



// WEBPACK FOOTER //
// ./src/reducers/application/actionConst.js